import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

interface ImportPdfsProps {
  show: boolean;
  onClose: () => void;
}

const ImportPdfs: React.FC<ImportPdfsProps> = ({ show, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState<{ current: number; total: number; title: string } | null>(null);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState<'success' | 'error' | 'info'>('info');

  useEffect(() => {
    if (!show) {
      setProgress(null);
      setMessage('');
      setLoading(false);
    }
  }, [show]);

  useEffect(() => {
    if (window.electronAPI?.onPosterProgress) {
      window.electronAPI.onPosterProgress((data: any) => {
        if (loading) setProgress(data);
      });
    }
  }, [loading]);

  const showMessage = (text: string, type: 'success' | 'error' | 'info') => {
    setMessage(text);
    setMessageType(type);
  };

  const handlePickZip = async () => {
    setLoading(true);
    setProgress(null);
    setMessage('');

    try {
      const result = await window.electronAPI.pickAndImportPdfsZip();

      if (result?.canceled) {
        setLoading(false);
        return;
      }

      showMessage(`✓ ${result.extracted} PDFs importados correctamente`, 'success');
      setTimeout(() => onClose(), 2000);
    } catch (error: any) {
      showMessage('✗ Error al importar: ' + (error?.message || error), 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={loading ? undefined : onClose} centered backdrop={loading ? 'static' : true}>
      <Modal.Header closeButton={!loading}>
        <Modal.Title>Importar PDFs desde ZIP</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-3">
          Seleccioná un archivo ZIP con los PDFs de los posters. Se extraerán a la carpeta local de la aplicación.
        </p>

        {message && (
          <div
            className={`alert alert-${
              messageType === 'success' ? 'success' : messageType === 'error' ? 'danger' : 'info'
            }`}
          >
            {message}
          </div>
        )}

        {loading && progress && progress.total > 0 && (
          <div className="mb-3">
            <div className="d-flex justify-content-between mb-1">
              <small>{progress.title}</small>
              <small>
                {progress.current} / {progress.total}
              </small>
            </div>
            <div className="progress">
              <div
                className="progress-bar"
                role="progressbar"
                style={{ width: `${(progress.current / progress.total) * 100}%` }}
              />
            </div>
          </div>
        )}

        <div className="d-flex gap-2">
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handlePickZip} disabled={loading}>
            {loading ? 'Importando...' : 'Seleccionar ZIP...'}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ImportPdfs;
